export default __webpack_public_path__ + "static/media/10.8b54a775.png";